import { useEffect, useState } from "react";
import { tx } from "../lib/i18n";

export const PageLoading = ({ after = 12000 }) => {
  const [slow, setSlow] = useState(false);
  useEffect(() => { const t = setTimeout(() => setSlow(true), after); return () => clearTimeout(t); }, [after]);
  if (!slow) return <span className="inline-flex items-center gap-2" data-testid="page-loading"><span className="h-3 w-3 animate-spin rounded-full border-2 border-[var(--mv-teal)] border-t-transparent" />{tx("Loading…")}</span>;
  return (
    <span className="inline-flex flex-wrap items-center gap-3" data-testid="page-loading-slow">
      {tx("This is taking longer than expected. Check your connection and try again.")}
      <button type="button" onClick={() => window.dispatchEvent(new Event("mivo:retry-route"))} className="rounded-full border border-[var(--mv-teal)] px-3 py-1 text-xs text-[var(--mv-teal)]" data-testid="page-loading-retry">{tx("Try again")}</button>
    </span>
  );
};
